var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMove = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-506.000000, -388.000000) translate(506.000000, 388.000000)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  rx: 2,
  fill: "#F5F7F9"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#830051",
  x: 3,
  y: 8.25,
  width: 11,
  height: 1.5,
  rx: 0.75
}), /*#__PURE__*/React.createElement("polyline", {
  stroke: "#830051",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(10.012144, 9.000000) rotate(-315.000000) translate(-10.012144, -9.000000)",
  points: "7.01214364 6 13.0121436 6 13.0121436 12"
}))));

export default SvgMove;